import React from 'react';

// @MUI
import { Avatar, Box, Button, Divider, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';

// COMPONENTS
import { ConnectKitButton } from 'connectkit';
import { useAccount, useDisconnect } from 'wagmi';
import { Link, useLocation } from 'react-router-dom';
import { pxToRem } from '../../utils/getFontValue';
import { SideBarData } from '../../utils/components-data';
import { Logo } from '../../assets/img';

// ----------------------------------------------------------------------

const SideBarNav = () => {
  const { isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { pathname } = useLocation();

  return (
    <Box
      component="aside"
      sx={{
        p: 2,
        bgcolor: 'grey.900',
        flex: 0.28,
        height: '100vh',
        position: 'sticky',
        left: 0,
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        maxWidth: pxToRem(350),
      }}
    >
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2 }}>
          <Avatar
            sx={{ width: pxToRem(64), height: pxToRem(64), background: '#fff' }}
            src={Logo}
          />
          <Typography fontWeight={700} variant="body1">
            Wojak Finance
          </Typography>
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            px: 1,
            rowGap: 2,
          }}
        >
          {SideBarData.map(({ id, icon, name, path }) => (
            <Box
              key={id}
              component={Link}
              to={path}
              sx={{
                display: 'flex',
                columnGap: 2,
                color: path === pathname ? 'primary.lighter' : '#fff',
                bgcolor: path === pathname && '#20243550',
                alignItems: 'center',
                cursor: 'pointer',
                p: 1.5,
                borderRadius: 3,
                textDecoration: 'none',
                ':hover': {
                  color: path !== pathname && 'primary.lighter',
                  bgcolor: path !== pathname && '#20243550',
                },
              }}
            >
              {icon}
              <Typography variant="body2" fontWeight={700}>
                {name}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 3 }}>
        <ConnectKitButton.Custom>
          {({ isConnected, show, address }) => (
            <Button
              onClick={show}
              variant="contained"
              sx={{
                bgcolor: 'primary.light',
                display: 'flex',
                alignItems: 'center',
                columnGap: 1,
                py: 1.5,
                borderRadius: 3,
                ':hover': {
                  bgcolor: 'primary.light',
                },
              }}
            >
              {isConnected ? (
                <AccountBoxIcon />
              ) : (
                <LoginIcon fontSize="small" />
              )}
              {!isConnected ? (
                <Box>Login</Box>
              ) : (
                <Box
                  sx={{ display: 'flex', justifyContent: 'center' }}
                >{`${address?.substring(0, 8)}...`}</Box>
              )}
            </Button>
          )}
        </ConnectKitButton.Custom>

        {isConnected && (
          <Button
            onClick={() => disconnect()}
            variant="contained"
            sx={{
              bgcolor: 'error.main',
              display: 'flex',
              alignItems: 'center',
              columnGap: 1,
              py: 1.5,
              borderRadius: 3,
              ':hover': {
                bgcolor: 'error.dark',
              },
            }}
          >
            <LogoutIcon />
            <span>DISCONNECT</span>
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SideBarNav;
